import React from "react";
import Icon from "components/AppIcon";

const skills = [
  { id: "stealth", label: "Stealth", icon: "EyeOff", level: 4, xp: 3200, xpNext: 5000, color: "var(--color-primary)", bonus: "+8% success on stealth crimes" },
  { id: "hacking", label: "Hacking", icon: "Terminal", level: 2, xp: 800, xpNext: 2000, color: "#a855f7", bonus: "+4% success on cyber crimes" },
  { id: "intimidation", label: "Intimidation", icon: "Skull", level: 3, xp: 1500, xpNext: 3000, color: "var(--color-error)", bonus: "+6% success on robbery" },
  { id: "forgery", label: "Forgery", icon: "FileText", level: 1, xp: 200, xpNext: 1000, color: "var(--color-accent)", bonus: "+2% success on fraud" },
];

const SkillProgressPanel = () => (
  <div className="rounded-xl p-4 md:p-5" style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}>
    <div className="flex items-center gap-2 mb-4">
      <Icon name="TrendingUp" size={16} color="var(--color-primary)" />
      <span className="font-heading text-sm font-semibold text-foreground">Criminal Skills</span>
    </div>
    <div className="space-y-3">
      {skills?.map((skill) => {
        const pct = Math.round((skill?.xp / skill?.xpNext) * 100);
        return (
          <div key={skill?.id}>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2">
                <Icon name={skill?.icon} size={13} color={skill?.color} />
                <span className="font-caption text-xs text-foreground">{skill?.label}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-caption text-xs text-muted-foreground">{skill?.xp?.toLocaleString()}/{skill?.xpNext?.toLocaleString()}</span>
                <span className="font-caption text-xs px-1.5 py-0.5 rounded" style={{ background: `${skill?.color}18`, color: skill?.color }}>Lvl {skill?.level}</span>
              </div>
            </div>
            <div className="h-1.5 rounded-full overflow-hidden" style={{ background: "rgba(0,0,0,0.3)" }}>
              <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, background: skill?.color }} />
            </div>
            <p className="font-caption text-xs text-muted-foreground mt-0.5">{skill?.bonus}</p>
          </div>
        );
      })}
    </div>
  </div>
);

export default SkillProgressPanel;